import "./EditableSpeakers.css"
import { useState } from "react";
import Popup from "reactjs-popup";
import EditIcon from '@mui/icons-material/Edit';
import UpdateSpeakers from "./package/UpdateSpeaker";
import CreateNewSpeaker from "./package/createNewSpeaker";
import DeleteSpeaker from "./package/deleteSpeaker";

const EditableSpeakers = ({ id, title, sPosition, speakerName, speakerDescription, isActionCreate }) => {
    const [name, setName] = useState(speakerName ?? "");
    const [description, setDescription] = useState(speakerDescription ?? "");
    const [position, setPosition] = useState(sPosition ?? "");
    const [profilePic, setProfilePic] = useState(null);
    const [btnLoading, setBtnLoading] = useState(false);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isActionCreate) {
            let success = await CreateNewSpeaker({
                name,
                position: position,
                description,
                editionId: id,
                btnLoading, setBtnLoading,
                profilePic
            });
            if (success) {
                refreshPage();
            }
        } else {
            let success = await UpdateSpeakers({
                speakerId: id,
                name: name,
                position: position,
                description: description,
                btnLoading: btnLoading,
                setBtnLoading: setBtnLoading,
                profilePic: profilePic,
            });
            if (success) {
                refreshPage();
            }
        }
    };

    const handleDeleteProfile = async (e) => {
        e.preventDefault();
        let success = await DeleteSpeaker({
            btnLoading: deleteBtnLoading,
            setBtnLoading: setDeleteBtnLoading,
            id: id ?? "",
        });
        if (success) {
            refreshPage();
        }
    };

    return (
        <Popup
            trigger={
                <div className="dt_trigger_btn">
                    {title ?
                        <div style={{ fontSize: "1.2rem", margin: "1rem 0" }}
                            className="primary_btn">
                            {title}
                        </div> :
                        <div className="dt_edit_btn" style={{ marginRight: "0.5rem" }} >
                            <EditIcon />
                        </div>
                    }
                </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup">
                        <div className="ehp_inner_container"
                            style={{
                                height: "85vh",
                            }} >
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header"  >
                                    {title ?? "Edit Speaker"}
                                </h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_left">
                                        <label htmlFor="name" className="ehp_label">
                                            Name:
                                        </label>
                                        <input
                                            id="name"
                                            value={name}
                                            type="text"
                                            onChange={(e) => {
                                                setName(e.target.value);
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="position" className="ehp_label">
                                            Title:
                                        </label>
                                        <input
                                            id="position"
                                            value={position}
                                            type="text"
                                            onChange={(e) => {
                                                setPosition(e.target.value);
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="position" className="ehp_label">
                                            Description:
                                        </label>
                                        <textarea
                                            id="position"
                                            value={description}
                                            onChange={(e) => {
                                                setDescription(e.target.value);
                                            }}
                                            style={{
                                                height: "14rem",
                                            }}
                                            className="ehp_input_field"
                                            placeholder=""
                                            required
                                        />
                                        <label htmlFor="profilePic" className="ehp_label">
                                            New Profile Picture:
                                        </label>
                                        {
                                            isActionCreate ?
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    required
                                                    className="ehp_file_input dt_pp_input"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                /> :
                                                <input type="file" name="file" id="profilePic"
                                                    accept="image/*"
                                                    className="ehp_file_input dt_pp_input"
                                                    onChange={(event) => {
                                                        setProfilePic(event.target.files[0]);
                                                    }}
                                                />
                                        }

                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    {
                                        isActionCreate ? "" :
                                            <input
                                                type="button"
                                                onClick={handleDeleteProfile}
                                                className="ehp_cancel primary_btn"
                                                value={deleteBtnLoading ? "Loading..." : "Delete"}
                                            />
                                    }
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup>
    );
};

export default EditableSpeakers;